import React, { useState, useEffect } from 'react';
import {StickyNavigationHeader} from "../../components/Navigation/StickyNavigationHeader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { authActions } from '../../store';
import { useSearchParams } from 'react-router-dom';
import { LanguageHeader } from '../../components/LanguageHeader';
import {EyeInvisibleOutlined, EyeOutlined} from "@ant-design/icons";
import {ImeanHeader} from "../../components/Header/Header";

export const CreateNewPassword = ({ onPasswordCreated }) => {
  const {t} = useTranslation()
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

    useEffect(() => {
        setEmail(searchParams.get('mail'));
        setToken(searchParams.get('token'));
    }, [searchParams]);

  const handleSubmit = async (event) => {
      event.preventDefault();
      if (password === confirmPassword) {
          const res = await dispatch(authActions.newPassword({
              username: email,
              token: token,
              newPassword: password
          }))
          if (res?.error === 'password_recovery_error') {
              navigate('/sign-in');
              //TODO: Вот тут при ошибке отображается стандартная ошибка "Неправильные учетные данные", хотя на данной форме их стоит изменить
          } else {
              navigate('/home')
          }
      } else {
          alert(t('newPassword.noMatch'));
      }
  };

  return (
    <>
        <LanguageHeader/>
        {/*<ImeanHeader initialDark={true}></ImeanHeader>*/}
        <StickyNavigationHeader headerTitle={t('newPassword.header')}
                                onBackClick={() => navigate('/sign-in')}></StickyNavigationHeader>
        <div className="forgot-password-container">
        <div className="content">
            <p>{t('newPassword.passwordRequirements')}</p>
          <div className='relative flex items-center'>
            <input
            type={isPasswordVisible ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('newPassword.placeholderCreate')}
            />
            <button type='button' className='absolute mb-3.5 right-2 h-1/2 flex items-center justify-center text-center px-2 aspect-square rounded-full hover:bg-purple-700/15'
                    onClick={()=>setIsPasswordVisible(p=>!p)}>
              {isPasswordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </button>
          </div>
          <div className='relative flex items-center'>
            <input
            type={isPasswordVisible ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder={t('newPassword.placeholderConfirm')}
            />
            <button type='button' className='absolute mb-3.5 right-2 h-1/2 flex items-center justify-center text-center px-2 aspect-square rounded-full hover:bg-purple-700/15'
                    onClick={()=>setIsPasswordVisible(p=>!p)}>
              {isPasswordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </button>
          </div>
            <button type='submit' onClick={handleSubmit}>{t('newPassword.continue')}</button>
        </div>
        </div>
    </>
  );
};
